import { t } from "ttag";

import type { Appointment } from "@/features/consultations/models";
import { APPOINTMENT_TYPE } from "@/features/consultations/models";

export const getDisabledConsultationOptionMessage = (
  hasUpcomingFollowUpConsultation: boolean,
  appointmentType?: Appointment["type"],
) => {
  if (appointmentType === APPOINTMENT_TYPE.OTHER) {
    return t`You already have a scheduled consultation for this purpose`;
  }

  return hasUpcomingFollowUpConsultation
    ? t`You already have a scheduled consultation for this purpose`
    : t`You already have a medication request for this purpose`;
};
